import { getcase } from './getcase';
import { GetCaseResponse } from '../getcase';
import { CaseStatus } from '../schema';

const POLLING_INTERVAL = 3000; // 3 seconds
const TIMEOUT = 900000; // 15 minutes

export const getCaseUntilGenerated = (
  caseId: string,
  token: string,
  setAccessToken: (token: string | null) => void,
  logout: () => void,
  onProgress?: (messages: string[]) => void
): Promise<GetCaseResponse> => {
  return new Promise((resolve, reject) => {
    let intervalId: NodeJS.Timeout;

    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
      reject(new Error('Polling timed out after 120 seconds.'));
    }, TIMEOUT);

    const poll = async () => {
      try {
        const response = await getcase({ caseId }, token, setAccessToken, logout);

        // Update progress messages if callback provided
        if (onProgress && response.progressMessages && response.progressMessages.length > 0) {
          onProgress(response.progressMessages);
        }

        if (
          response.status === CaseStatus.REPORT_GENERATED ||
          response.status === CaseStatus.PENDING_ASSIGNMENT ||
          response.status === CaseStatus.PENDING_REVIEW ||
          response.status === CaseStatus.REVIEW_FINALIZED
        ) {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
          resolve(response);
        } else if (response.status === CaseStatus.GENERATION_FAILED) {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
          resolve(response);
        }
      } catch (error) {
        // Don't reject on polling error, just log it and continue polling
        console.error('Error during polling:', error);
      }
    };

    intervalId = setInterval(poll, POLLING_INTERVAL);
    poll(); // Initial call
  });
};